import Breakpoints from 'components/style/Breakpoints.style';
import { Fade } from 'reactstrap';
import styled from 'styled-components';

export const NotificationColumn = styled.div`
  position: fixed;
  z-index: 1080;
  right: 10px;
  top: 0px;
  display: flex;
  flex-flow: column nowrap;

  @media only screen and (max-width: ${Breakpoints.sm}) {
    left: 0;
    right: 0;

    left: 50%;
    transform: translate(-50%, 0);
    right: initial;
  }
`;

export const Box = styled(Fade)`
  margin-top: 1rem;
  border-radius: 15px;
  padding: 10px 5px;
  min-width: 360px;
  max-width: 400px;
  min-height: 100px;
  background-color: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  :hover {
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/Notification/Notification.style.js